import roleService from '@/services/role.js';

export default {
	debug: false,
	namespaced: true,
	state: {
		roles: [],
		dropdownRoles: [],
		role: {},
		roundRoles: [],
		searchParams: {
			name: '',
			customerId: '',
			orderBy: 'Created',
			pageSize: 10,
			currentPage: 1
		},
		totalCount: 0,
		totalPages: 0
	},

	mutations: {
		SET_ROLES(state, roles) {
			state.roles = roles;
		},
		SET_DROPDOWN_ROLES(state, roles) {
			state.dropdownRoles = roles;
		},
		SET_ROLE(state, role) {
			state.role = role;
		},
		SET_ROUND_ROLES(state, roles) {
			state.roundRoles = roles;
		},
		SET_PAGESIZE(state, pageSize) {
			state.searchParams.pageSize = pageSize;
		},
		SET_CURRENTPAGE(state, currentPage) {
			state.searchParams.currentPage = currentPage;
		},
		SET_TOTALPAGES(state, totalPages) {
			state.totalPages = totalPages;
		},
		SET_TOTALCOUNT(state, totalCount) {
			state.totalCount = totalCount;
		}
	},

	actions: {
		async getRole({ commit }, roleId) {
			return await roleService
				.getRole(roleId)
				.then(data => {
					commit('SET_ROLE', data);
				})
				.catch(err => {
					console.log('Error getting role: ', err);
				});
		},

		async getRoles({ state, commit, dispatch }) {
			dispatch('appStore/setLoading', 1, { root: true });

			return await roleService
				.getRoles(state.searchParams)
				.then(data => {
					const paginationValues = data._pagination;

					if (state.searchParams.currentPage <= paginationValues.totalPages || paginationValues.totalPages == 0) {
						commit('SET_ROLES', data);
						commit('SET_CURRENTPAGE', paginationValues.currentPage);
						commit('SET_TOTALCOUNT', paginationValues.totalCount);
						commit('SET_TOTALPAGES', paginationValues.totalPages);
					} else {
						commit('SET_CURRENTPAGE', paginationValues.totalPages);
						dispatch('getRoles');
					}

					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting roles: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},

		async getDropdownRoles({ commit, dispatch }, customerId) {
			dispatch('appStore/setLoading', 1, { root: true });
			var searchParams = {
				customerId: customerId,
				orderBy: 'Name',
				currentPage: 1,
				pageSize: 0
			};

			return await roleService
				.getRoles(searchParams)
				.then(data => {
					commit('SET_DROPDOWN_ROLES', data);
					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting roles: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},

		async getAllRoles({ commit, dispatch }, params) {
			dispatch('appStore/setLoading', 1, { root: true });
			var searchParams = {
				name: params.search,
				customerId: params.customerId,
				orderBy: 'Name',
				currentPage: 1,
				pageSize: 1000
			};

			return await roleService
				.getRoles(searchParams)
				.then(data => {
					commit('SET_ROLES', data);
					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting roles: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},

		async getRoundRoles({ commit, dispatch }, roundPlanningId) {
			dispatch('appStore/setLoading', 1, { root: true });
			var searchParams = {
				roundPlanningId,
				orderBy: 'Name',
				currentPage: 1,
				pageSize: 1000
			};

			return await roleService
				.getRoles(searchParams)
				.then(data => {
					commit('SET_ROUND_ROLES', data);
					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting fireprotections: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},

		async createRole({ dispatch }, role) {
			return await roleService
				.createRole(role)
				.then(() => {
					dispatch('getRoles');
				})
				.catch(err => {
					console.log('Error creating role: ', err);
				});
		},

		async updateRole({ dispatch }, role) {
			return await roleService
				.updateRole(role)
				.then(() => {
					dispatch('getRoles');
				})
				.catch(err => {
					console.log('Error updating role: ', err);
				});
		},

		async deleteRole({ dispatch }, role) {
			return await roleService
				.deleteRole(role.id)
				.then(() => {
					dispatch('getRoles');
				})
				.catch(err => {
					console.log('Error deleting role: ', err);
				});
		},

		setRole({ commit }, role) {
			commit('SET_ROLE', role);
		},
		setRoles({ commit }, role) {
			commit('SET_ROLES', role);
		},
		setCurrentPage({ commit }, currentPage) {
			commit('SET_CURRENTPAGE', currentPage);
		},
		setPageSize({ commit }, pageSize) {
			commit('SET_PAGESIZE', pageSize);
		},
		setTotalPages({ commit }, totalPages) {
			commit('SET_TOTALPAGES', totalPages);
		},
		setTotalCount({ commit }, totalCount) {
			commit('SET_TOTALCOUNT', totalCount);
		}
	},

	getters: {
		totalPages: state => {
			return state.totalPages;
		},
		totalCount: state => {
			return state.totalCount;
		},
		currentPage: state => {
			return state.searchParams.currentPage;
		},
		pageSize: state => {
			return state.searchParams.pageSize;
		},
		roles: state => {
			return state.roles;
		},
		roundRoles: state => {
			return state.roundRoles;
		},
		dropdownRoles: state => {
			return state.dropdownRoles;
		},
		role: state => {
			return state.role;
		},
		pagination: state => {
			return {
				currentPage: state.searchParams.currentPage,
				pageSize: state.searchParams.pageSize,
				totalPages: state.totalPages,
				totalCount: state.totalCount
			};
		}
	}
};
